<template>
  <div class="demo_basic_config" :style="screenHeight" >
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <Tabs v-model="tabValue" @on-click="changeTab">
      <TabPane label="基础配置" name="1" :style="tanPaneHeight">
        <div class="input_style">
          <div class="font_style_set">隐藏电话号码:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="phoneIsHide" type="button">
              <Radio v-for="(option, index) in isUseList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">时间显示格式:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="timeShowStyle" type="button">
              <Radio v-for="(option, index) in timeShowList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">显示号码归属地:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="phoneOwnership" type="button">
              <Radio v-for="(option, index) in phoneOwnershipList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">弹屏保存自动关闭:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="autoClose" type="button">
              <Radio v-for="(option, index) in isUseList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">弹屏后客户经理允许修改:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="isAllowModify" type="button">
              <Radio v-for="(option, index) in isUseList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">部门经理通话记录查看未接来电:</div>
          <div class="bas_config_content" style="width: auto;">
            <RadioGroup v-model="isSeeMisscall" type="button">
              <Radio v-for="(option, index) in isUseList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
          <Tooltip class="tips_font" placement="top" content="开启后,部门经理可在通话记录查看主叫在IVR或技能组排队时挂断的话单"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">外置话机设置呼出自动接听:</div>
          <div class="bas_config_content" style="width: auto;">
            <RadioGroup v-model="externalPhoneAutoAnswer" type="button">
              <Radio v-for="(option, index) in isUseList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
          <Tooltip class="tips_font" placement="top" content="主要针对IP硬件话机,需要话机设备支持该协议"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style" v-if="companyType!='0'">
          <div class="font_style_set">强制满意度:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="forceEvalue" type="button">
              <Radio v-for="(option, index) in isUseList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style" v-if="sysSupportWorkOrder!='0'">
          <div class="font_style_set">弹屏默认打开界面:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="screenShow" type="button">
              <Radio v-for="(option, index) in screenShowList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style" v-if="sysSupportWorkOrder!='0'">
          <div class="font_style_set">服务信息:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="isHiddenService" type="button">
              <Radio v-for="(option, index) in hiddenServiceList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">每天可申请客户号码数量:</div>
          <div class="bas_config_content">
            <Input v-model="phoneNumber" :value="phoneNumber" name="每天可申请客户号码数量" @on-blur="checkPhoneNumber"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="必须是大于0的整数,等于0表示不受限制"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">每个座席最大拥有客户数:</div>
          <div class="bas_config_content">
            <Input v-model="maxAgent" :value="maxAgent"  name="每个座席最大拥有客户数" @on-blur="checkPhoneNumber"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="必须是大于0的整数,等于0表示不受限制"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">默认待回访天数(天):</div>
          <div class="bas_config_content">
            <Input v-model="waitVisitDays" :value="waitVisitDays"  name="默认待回访天数" @on-blur="checkPhoneNumber"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="必须是大于0的整数,等于0表示不受限制"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">拒接后恢复座席状态时间(秒):</div>
          <div class="bas_config_content">
            <Input v-model="recoveryTime" :value="recoveryTime"  name="拒接后恢复座席状态时间"  @on-blur="checkPhoneNumber"/>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">未联系客户自动回滚公海设置:</div>
          <div class="bas_config_content" style="width: 20%">
            <Select v-model="seaSet" :transfer="true" multiple :max-tag-count="2" placeholder="请选择回滚客户类型,可进行多项选择" title="回滚客户类型">
              <Option v-for="(item,index) in seaSetList" :value="item.id" :key="index">{{item.dictValue}}</Option>
            </Select>
          </div>
          <div class="bas_config_content" style="width: 20%;">
            <Input v-model="recoveryDays" :value="recoveryDays" placeholder="n天未联系客户自动回滚至公海" title="待回收天数" style="height: 32px;width: 90%;float: right" name="n天未联系客户自动回滚至公海" @on-blur="checkPhoneNumber"/>
          </div>
          <div class="bas_config_content" style="width: 20%;">
            <Input v-model="recoveryNoticeTime" :value="recoveryNoticeTime" placeholder="n天未联系客户提醒" title="n天未联系客户提醒" style="height: 32px;width: 90%;float: right" name="n天未联系客户提醒" @on-blur="checkPhoneNumber"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="大于等于0的整数，等于0表示不启用"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">后处理时长(秒):</div>
          <div class="bas_config_content">
            <Input v-model="handleTime"  :value="handleTime" name="后处理时长" @on-blur="checkPhoneNumber"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="大于等于0的整数，等于0表示不启用"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">停用挂断后座席状态:</div>
          <div class="bas_config_content">
            <Select v-model="stopAgentStatus" filterable multiple clearable :max-tag-count="5" placeholder="可进行多项选择">
              <Option v-for="(item,index) in stopAgentStatusList" :value="item.id" :key="index">{{ item.name}}</Option>
            </Select>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">振铃配置:</div>
          <div class="bas_config_content">
            <Select v-model="selRing">
              <Option v-for="(option, index) in ringList" :value="option.id" :key="index">{{option.ringName}}</Option>
            </Select>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">首页LOGO:</div>
          <div class="bas_config_content">
            <Input v-model="companyLogo"  title="首页LOGO图片地址"  disabled="disabled"/>
          </div>
          <Upload :action="uploadUrl" :show-upload-list="showUploadList" :on-success="handleSuccessVoiceType" :before-upload="handleUpload" :on-error="handleFail" :format="format" :max-size="1025*500">
            <Button icon="ios-cloud-upload-outline">首页LOGO上传</Button>
          </Upload>
        </div>
      </TabPane>
      <TabPane label="短信服务商设置" name="2" :style="tanPaneHeight">
        <div class="input_style">
          <div class="font_style_set">短信接口名称:</div>
          <Dropdown trigger="click">
            <Input v-model="templateName"  name="后处理时长"/>
            <DropdownMenu slot="list">
              <table style="width: 100%">
                <tr class="table_th">
                  <th style="width:45%;">模板名称</th>
                  <th style="width:45%;">模板状态</th>
                  <th style="width:10%;border-right: 0px">操作</th>
                </tr>
                <tr class="table_td" v-for="(item , index) in noteList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}" @click="handleTemplateName(noteList[index])">
                  <td style="width:45%;overflow: hidden" v-if="item.id" :title="item.templateName">{{item.templateName}}</td>
                  <td style="width:45%;" v-if="!item.id" >新增模板</td>
                  <td style="width:45%;" v-if="item.id">{{item.isUse=='0'?'未使用':'使用中'}}</td>
                  <td class="template_table_btn" style="width:10%;">
                    <span class="search_btn" v-show="item.id" @click="deleteTemplate(item.id)">删除</span>
                  </td>
                </tr>
              </table>
            </DropdownMenu>
          </Dropdown>
          <Tooltip class="tips_font" placement="bottom"><img :src="questionMark"/>
            <div slot="content">
              对历史模板进行选择或删除,当列表中选择空白模板时<br/>
              将根据输入的模板名称进行模板新建
            </div>
          </Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">启用:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="isUse" type="button" placeholder="是否启用">
              <Radio v-for="(option, index) in isUseList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set"><span style="color: red">*</span>短信接口URL:</div>
          <div class="bas_config_content">
            <Input v-model="noteUrl"/>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">请求类型:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="type" type="button" placeholder="请选择请求类型">
              <Radio v-for="(option, index) in requestTypeList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="textarea">
          <div class="font_style_set">请求头:</div>
          <div class="bas_config_content">
            <Input v-model="requestHead" class="input_content" type="textarea"/>
          </div>
          <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
            <div slot="content">
              输入短信接口文档中标注的请求头，请求头参数及参数值在“{}”中进行书写<br/>
              (参数名及参数值格式为：”paraml”:”value”)，多个参数之间使用“,”进行间隔<br/>
              例如：{"param1":"value1","param2":"value2",......,"paramN":"valueN"}<br/>
            </div>
          </Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">请求参数类型:</div>
          <div class="bas_config_content">
            <RadioGroup v-model="paramType" type="button" placeholder="请选择请求参数类型">
              <Radio v-for="(option, index) in paramTypeList" :label="option.id" :key="index">{{option.name}}</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set"></div>
          <div class="bas_config_content" style="text-align: center">
            <Button type="primary" class="submit_btn" @click="addParam(1)">电话号码</Button>
            <Button type="primary" style="margin-left: 30px" class="search_btn reset_btn"  @click="addParam(2)">短信内容</Button>
          </div>
          <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
            <div slot="content">
              通过点击电话号码或短信内容按钮，在下方请求参数中产生<br/>
              相应的参数引用标识 (电话号码参数引用标识为{telphone}<br/>
              短信内容参数引用标识为{content})<br/>
              {telphone}：该标识将会引用短信发送界面中的接受手机号<br/>
              输入框中的输入的内容<br/>
              {content}：该表示将会引用短信发送界面中的发送内容<br/>
              输入框中输入的内容<br/>
            </div>
          </Tooltip>
        </div>
        <div class="textarea">
          <div class="font_style_set"><span style="color: red">*</span>请求参数:</div>
          <div class="bas_config_content">
            <Input v-model="requestBody" :rows="4" class="input_content" type="textarea"/>
          </div>
          <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
            <div slot="content">
              在输入框中输入相应的请求参数(包括参数名以及参数值),存在多个参数时<br/>
              根据接口文档要求进行拼接<br/>
              例如：clientid=a00012&password=1bbd886460827015e5d605ed44252251<br/>
              &mobile={telphone}&smstype=0&content={content}<br/>
            </div>
          </Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set"><span style="color: red">*</span>成功标识:</div>
          <div class="bas_config_content">
            <Input v-model="successCode"/>
          </div>
          <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
            <div slot="content">
              在输入框中输入短信发送成功后的返回标识（需要加上标识字段）<br/>
              例如：&lt;returnstatus>Success&lt;/returnstatus><br/>
            </div>
          </Tooltip>
        </div>
      </TabPane>
      <TabPane label="邮件服务器设置" name="3" :style="tanPaneHeight">
        <div class="input_style">
          <div class="font_style_set">发件箱地址:</div>
          <div class="bas_config_content">
            <Input v-model="outEmailAddress" placeholder="发送者邮箱" type="email"/>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">邮件服务器:</div>
          <div class="bas_config_content">
            <Input v-model="mailServer" placeholder="配置SMTP服务器地址"/>
          </div>
          <Tooltip class="tips_font" placement="bottom"><img :src="questionMark"/>
            <div slot="content">
              126邮箱SMTP服务器地址:smtp.126.com,端口号:465或者994<br/>
              163邮箱SMTP服务器地址:smtp.163.com,端口号:465或者994<br/>
              yeah邮箱SMTP服务器地址:smtp.yeah.net,端口号:465或者994<br/>
              qq邮箱SMTP服务器地址：smtp.exmail.qq.com,端口号465或587<br/>
            </div>
          </Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">邮件服务器端口:</div>
          <div class="bas_config_content">
            <Input v-model="mailServerPort" placeholder="邮件服务器端口"/>
          </div>
        </div>
        <div class="input_style">
          <div class="font_style_set">邮箱认证:</div>
          <div class="bas_config_content">
            <Input v-model="emailAuthentication" placeholder="邮箱认证帐号或授权认证机制(例:mail.smtp.auth)"/>
          </div>
        </div>
<!--        <div class="input_style">-->
<!--          <div class="font_style_set">用户名:</div>-->
<!--          <div class="bas_config_content">-->
<!--            <Input v-model="userName" placeholder="发送者邮箱"/>-->
<!--          </div>-->
<!--        </div>-->
        <div class="input_style">
          <div class="font_style_set">密码:</div>
          <div class="bas_config_content">
            <Input v-model="passWord" type="password" placeholder="邮箱密码或授权码"/>
          </div>
        </div>
        <div v-show="passWord && mailServer && outEmailAddress" class="input_style">
          <div class="bas_config_content" style="width:100%;text-align: center;margin-right: 13%;">
            <Button type="primary" class="submit_btn" @click="testSendMail()">测试邮箱</Button>
          </div>
        </div>
      </TabPane>
      <TabPane label="大屏页面设置" name="5" :style="tanPaneHeight">
        <div class="input_style">
          <div class="font_style_set">大屏背景:</div>
          <div class="bas_config_content">
            <Input v-model="bigScreenBgp"  title="大屏背景地址"  disabled="disabled"/>
          </div>
          <Upload :action="uploadUrlOne" :show-upload-list="showUploadList" :on-success="handleSuccessOne" :before-upload="handleUploadOne" :on-error="handleFail" :format="format" :max-size="1024*1000">
            <Button icon="ios-cloud-upload-outline">大屏背景上传</Button>
          </Upload>
          <Tooltip class="tips_font" placement="top" content="建议图片大小 1920*1080"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">大屏LOGO:</div>
          <div class="bas_config_content">
            <Input v-model="bigScreenLogo"  title="大屏LOGO图片地址"  disabled="disabled"/>
          </div>
          <Upload :action="uploadUrlOne" :show-upload-list="showUploadList" :on-success="handleSuccessTwo" :before-upload="handleUpload" :on-error="handleFail" :format="format" :max-size="1024*500">
            <Button icon="ios-cloud-upload-outline">大屏LOGO上传</Button>
          </Upload>
          <Tooltip class="tips_font" placement="top" content="建议图片大小 170*40"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">通话总览大屏名称:</div>
          <div class="bas_config_content">
            <Input v-model="callView" name="title" maxlength="10"/>
          </div>
           <Tooltip class="tips_font" placement="top" content="最多输入10位字数"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">座席职场大屏名称:</div>
          <div class="bas_config_content">
            <Input v-model="workPlace" name="title" maxlength="10" />
          </div>
          <Tooltip class="tips_font" placement="top" content="最多输入10位字数"><img :src="questionMark"/></Tooltip>
        </div>
      </TabPane>
      <TabPane label="快速应用设置" name="7" :style="tanPaneHeight" style="margin-left:-5%;">
        <div class="input_style" v-for="(fastItem, fastIndex) in fastApplication" :key="fastIndex" :item="fastItem" style="margin-left:-20px;">
          <div class="font_style_set">显示名称:</div>
          <div class="bas_config_content">
            <i-input :value.sync="fastItem.name" v-model="fastItem.name"></i-input>
          </div>
          <div class="font_style_set">链接地址:</div>
          <div class="bas_config_content">
            <i-input :value.sync="fastItem.value" v-model="fastItem.value" placeholder="请输入以http/https开头的网址"></i-input>
          </div>
          <div style="margin-left:15px">
              <img :src="addImgPath" v-if="fastIndex == 0" @click="addfastApplication()"/>
              <img :src="delImgPath" v-if="fastIndex != 0" @click="delfastApplication(fastIndex)"/>
          </div>
        </div>
      </TabPane>
    </Tabs>
    <div class="btn_template">
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
      <Button type="primary" style="margin-right: 10px" class="search_btn reset_btn"  @click="initPage()">重置</Button>
    </div>
    <RecodePop @closeRecode="closeRecode" :showRecode="showRecode" :tipserror="tipsError"></RecodePop>
    <el-dialog
      class="basic_dialog"
      title="提示"
      :visible.sync="dialogVisible"
      width="25%">
      <div v-if="showFail" style="text-align: center"><p>测试邮件发送失败，请点击<a style="color: #0a90f5" href="javascript:void(0)" @click="showDetail('1')">查看详情</a></p></div>
      <div v-else style="text-align: center"><p>操作成功，测试邮件已发送</p></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="enterButton">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import RecodePop from '@/components/statisticsReportForm/detailedReportForm/RecodePop.vue'
    export default {
        name: "BasicConfig",
        mixins:[publicFunClass],
        components:{RecodePop},
        props:{
          seaSetList:Array,
          pageCode:String
        },
        data () {
          return {
            roleList:JSON.parse(localStorage.getItem("roleList")),
            uploadUrl:this.baseURL+"common/upload.json?type=companyLogo&companyNo="+localStorage.getItem("companyId"),
            uploadUrlOne:this.baseURL+"common/upload.json?type=bigScreen&companyNo="+localStorage.getItem("companyId"),
            showPageCount:0,
            screenHeight:{height:''},
            tanPaneHeight:{height:''},
            format:['jpg','jpeg','png','gif'],
            showUploadList:false,
            spinShow: true,
            templateName:'',
            noteList:[],
            tabValue:'1',
            phoneIsHide:'0',
            phoneNumber:'1',
            maxAgent:'1',
            waitVisitDays:'3',
            recoveryTime:'0',
            handleTime:'',
            // unallocatedWorkOrderTime:'',
            // unsolvedWorkOrderTime:'',
            questionMark:require('../../assets/image/homeAsk.png'),
            addImgPath: require('../../assets/image/add.png'),
            delImgPath: require('../../assets/image/minus.png'),
            autoClose:'1',
            isAllowModify:'1',
            isSeeMisscall:'0',
            externalPhoneAutoAnswer:'0',
            forceEvalue:'0',
            isUseList:[{'id':'0','name':'不启用'},{'id':'1','name':'启用'}],
            phoneOwnership:'0',
            phoneOwnershipList:[{'id':'0','name':'否'},{'id':'1','name':'是'}],
            stopAgentStatus:[],
            stopAgentStatusList:[{'id':'0','name':'挂断后空闲'},{'id':'4','name':'挂断后处理'},{'id':'8','name':'挂断仅呼出'}],
            seaSet:[],
            recoveryDays:'5',
            recoveryNoticeTime:'0',
            noteUrl:'',
            requestHead:'',
            successCode:'',
            requestBody:'',
            noteSupplierList:[{'id':'0','name':'短信接口1'},{'id':'1','name':'短信接口2'},{'id':'2','name':'短信接口3'}],
            outEmailAddress:'',
            mailServer:'',
            mailServerPort:'',
            emailAuthentication:'',
            userName:'',
            passWord:'',
            receiveEmailAddress:'',
            configValue:{},
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            selRing:'',
            ringList:[],
            timeShowStyle:'1',
            companyLogo:'',
            disabled:false,
            timeShowList:[{'id':'0','name':'时分秒'},{'id':'1','name':'秒'}],
            configId:'',
            type:'0',
            requestTypeList:[{'id':'0','name':'post'},{'id':'1','name':'get'}],
            paramType:'0',
            paramTypeList:[{'id':'0','name':'form'},{'id':'1','name':'json'}],
            isUse:'0',
            bigScreenLogo:'',
            bigScreenBgp:'',
            callView:'',
            workPlace:'',
            companyType:localStorage.getItem("companyType"),
            sysSupportWorkOrder: JSON.parse(localStorage.getItem("sysSupportWorkOrder")),
            fastApplication: [{
                "name": "",
                "value": ""
            }],
            isHiddenService:'0',
            screenShow:'0',
            hiddenServiceList:[{'id':'0','name':'显示'},{'id':'1','name':'隐藏'}],
            screenShowList:[{'id':'0','name':'客户信息'},{'id':'1','name':'工单信息'}],
            showRecode:false,
            tipsError:'',
            dialogVisible:false,
            showFail:false,
          }
        },
      methods:{
        enterButton:function(){
          this.dialogVisible = false;
        },
        closeRecode:function () {
          this.showRecode=false;
        },
        testSendMail:function(){
          let that = this;
          this.$prompt('请输入收件人邮箱', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: '邮箱格式不正确',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                let param = {
                  nickName:'测试发送邮件',
                  receiveEmailAddress:instance.inputValue,
                  journalType:"系统管理=>基本配置=>测试邮件发送",
                  menuId:"null",
                  sendType:'1',
                  outEmailAddress:this.outEmailAddress,
                  mailServer:this.mailServer,
                  mailServerPort:this.mailServerPort,
                  emailAuthentication:this.emailAuthentication,
                  passWord:this.passWord,
                };
                that.$http.post("message/doSendEmail.json",param) .then(function (res) {
                  let result=res.data.flag;
                  done();
                  setTimeout(() => {
                    instance.confirmButtonLoading = false;
                  }, 300);
                  if(result!="666"){
                    that.tipsError=res.data.obj;
                    setTimeout(() => {
                      that.showDetail();
                    }, 300);
                    return false;
                  }
                  that.showFail = false;
                  that.dialogVisible = true;
                })
              } else {
                done();
                instance.confirmButtonLoading = false;
              }
            }
          }).then(() => {})
        },
        showDetail:function(flag){
          if(!flag){
            this.showFail = true;
            this.dialogVisible = true;
            return false;
          }
          this.dialogVisible = false;
          this.showRecode = true;
        },
        handleUpload(file){
          let fileSize=parseInt(file.size/1024);
          let type=file.name.substr(file.name.length-4,4);
          if (!(type.indexOf("jpg")!=-1 || type.indexOf("jpeg")!=-1 || type.indexOf("png")!=-1)) {
            this.$Modal.info({
              title:'提示',
              content:"文件"+file.name+"类型必须为jpg/jpeg/png"
            });
            return false;
          }
          if (fileSize>500) {
            this.$Modal.info({
              title:'提示',
              content:"文件"+file.name+"尺寸太大,图片不能超过500KB"
            });
            return false;
          }
          this.$Loading.start();
        },
        handleUploadOne(file){
          let fileSize=parseInt(file.size/1024);
          let type=file.name.substr(file.name.length-4,4);
          if (!(type.indexOf("jpg")!=-1 || type.indexOf("jpeg")!=-1 || type.indexOf("png")!=-1 || type.indexOf("gif")!=-1)) {
            this.$Modal.info({
              title:'提示',
              content:"文件"+file.name+"类型必须为jpg/jpeg/png/gif"
            });
            return false;
          }
          if (fileSize>10000) {
            this.$Modal.info({
              title:'提示',
              content:"文件"+file.name+"尺寸太大,图片不能超过10MB"
            });
            return false;
          }
          this.$Loading.start();
        },
        handleSuccessVoiceType:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.companyLogo=res.obj.absolutePath;
          this.$Loading.finish();
        },
        handleSuccessOne:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.bigScreenBgp=res.obj.absolutePath;
          this.$Loading.finish();
        },
        handleSuccessTwo:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.bigScreenLogo=res.obj.absolutePath;
          this.$Loading.finish();
        },
        handleFail:function (error, file) {
          this.$Modal.info({
            title:'提示',
            content:file.response.msg
          });
          this.$Loading.error();
        },
        addParam:function(flag){
          if(flag==1){
            this.requestBody = this.requestBody+"{telphone}";
          }else{
            this.requestBody = this.requestBody+"{content}";
          }
        },
        handleTemplateName:function(list){
          this.configId=list.id;
          this.isUse="1";
          this.noteUrl=list.noteUrl;
          this.paramType=list.paramType;
          this.requestBody=list.requestBody;
          this.type=list.type;
          this.requestHead=list.requestHead;
          this.successCode=list.successCode;
          this.templateName=list.templateName;
        },
        deleteTemplate:function(id){
          let param={
            journalType:"基本配置=>短信服务商设置=>短信模板删除",
            menuId:"null",
            id:id
          };
          let that=this;
          that.$Modal.confirm({
            title: '提示',
            content: "是否确定删除",
            onOk: () => {
              that.$http.post("config/doDelete.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$alert(res.data.msg, '提示', {
                    confirmButtonText: '确定'
                  });
                  return false;
                }
                that.$Message.info("删除成功");
                //调用查询历史模板的接口
                that.initPage();
              })
            }
          });
        },
        checkPhoneNumber:function(event){
          let name=event.currentTarget.name;
          let value=event.currentTarget.value;
          let reg=/^[0-9]*$/;
          if(!reg.test(value)){
            this.$Modal.info({
              title:'提示',
              content:name+"只能输入数字"
            });
            return false;
          }
        },
        addfastApplication() {
            this.fastApplication.push({
                "name": "",
                "value": ""
            });
        },
        delfastApplication(index) {
            this.fastApplication.splice(index, 1);
        },

        save:function () {
          if(!this.phoneNumber){
            this.phoneNumber="1";
          }
          let reg=/^[0-9]*$/;
          if(!reg.test(this.phoneNumber)){
            this.$Modal.info({
              title:'提示',
              content:"每天可申请客户号码数量一栏只能输入数字"
            });
            return false;
          }
          this.configValue={};
          if(this.tabValue=="1"){
            this.configValue["companyLogo"]=this.companyLogo;
            this.configValue["timeShowStyle"]=this.timeShowStyle;
            this.configValue["phoneIsHide"]=this.phoneIsHide;
            this.configValue["phoneOwnership"]=this.phoneOwnership;
            this.configValue["selRing"]=this.selRing;
            this.configValue["requestCustomerNum"]=this.phoneNumber ? this.phoneNumber : "0";
            this.configValue["agentMaxCustomersNum"]=this.maxAgent ? this.maxAgent : "0";
            this.configValue["waitVisitDays"]=this.waitVisitDays ? this.waitVisitDays : "0";
            this.configValue["resumAgentWhenRejectStatus"]=this.recoveryTime ? this.recoveryTime : "0";
            this.configValue["seaSet"]=this.seaSet.toString();
            this.configValue["recoveryDays"]=this.recoveryDays ? this.recoveryDays : "0";
            this.configValue["recoveryNoticeTime"]=this.recoveryNoticeTime ? this.recoveryNoticeTime : "0";
            this.configValue["afterDoTime"]=this.handleTime;
            this.configValue["agentState"]=this.stopAgentStatus.toString();
            this.configValue["popSaveFlag"]=this.autoClose;
            this.configValue["isModifyManager"]=this.isAllowModify;
            this.configValue["isSeeMisscall"]=this.isSeeMisscall;
            this.configValue["externalPhoneAutoAnswer"]=this.externalPhoneAutoAnswer;
            this.configValue["forceEvalue"]=this.forceEvalue;
            this.configValue["isHiddenService"]=this.isHiddenService;
            this.configValue["screenShow"]=this.screenShow;
          }
          if(this.tabValue=="2"){
            if(!this.noteUrl){
              this.$Modal.info({
                title:'提示',
                content:"请输入请求地址"
              });
              return false;
            }
            if(!this.requestBody){
              this.$Modal.info({
                title:'提示',
                content:"请输入请求参数"
              });
              return false;
            }
            if(!this.successCode){
              this.$Modal.info({
                title:'提示',
                content:"请输入成功标识"
              });
              return false;
            }
            this.configValue["isUse"]=this.isUse;
            this.configValue["url"]=this.noteUrl;
            this.configValue["type"]=this.type;
            this.configValue["head"]=this.requestHead;
            this.configValue["paramType"]=this.paramType;
            this.configValue["body"]=this.requestBody;
            this.configValue["successCode"]=this.successCode;
            this.configValue["templateName"]=this.templateName;
          }
          if(this.tabValue=="3"){
            this.configValue["outEmailAddress"]=this.outEmailAddress;
            this.configValue["mailServer"]=this.mailServer;
            this.configValue["mailServerPort"]=this.mailServerPort;
            this.configValue["emailAuthentication"]=this.emailAuthentication;
            this.configValue["userName"]=this.userName;
            this.configValue["passWord"]=this.passWord;
            this.configValue["receiveEmailAddress"]=this.receiveEmailAddress;
          }
          if(this.tabValue=="5"){
            this.configValue["bgImg"]=this.bigScreenBgp;
            this.configValue["logo"]=this.bigScreenLogo;
            this.configValue["callView"]=this.callView;
            this.configValue["workPlace"]=this.workPlace;
            this.configValue["callTrends"]='';
            this.configValue["empStatus"]='';
            this.configValue["skillGroup"]='';
            this.configValue["callAnalysis"]='';
            this.configValue["satisfactionEvaluation"]='';
          }
          if(this.tabValue=="7"){
            //let regurl= /^(http[s]{0,1}?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
            let regurl=/(http|https):\/\/([\w.]+\/?)\S*/;
            for (let i = 0; i < this.fastApplication.length; i++) {
                if(this.fastApplication[i].value!=""&&this.fastApplication[i].name==""){
                    this.$Modal.info({
                      title:'提示',
                      content:"请输入显示名称"
                    });
                    return false;
                }
                if(this.fastApplication[i].name!=""&&this.fastApplication[i].value==""){
                    this.$Modal.info({
                      title:'提示',
                      content:"请输入链接地址"
                    });
                    return false;
                }
                if(!regurl.test(this.fastApplication[i].value)&&this.fastApplication[i].value!=""){
                  this.$Modal.info({
                  title:'提示',
                  content:"请输入规范的网址"
                  });
                  return false;
                }
                if(this.fastApplication[i].name==""&&this.fastApplication[i].value==""&&this.fastApplication.length!=1){
                  this.$Modal.info({
                  title:'提示',
                  content:"提交内容不能为空"
                  });
                  return false;
                }

            }
           this.configValue=this.fastApplication;
          }
          let param={
            configValue:JSON. stringify(this.configValue),
            journalType:"基本配置=>保存",
            menuId:"null",
            type:this.tabValue,
            id:this.configId,
            isUse:this.isUse
          };
          let that=this;
          this.spinShow=true;
          this.$http.post("config/doSave.json",param) .then(function (res) {
            let result = res.data.flag;
            that.spinShow=false;
            if (result != "666") {
              that.$Modal.info({
                title: '提示',
                content: res.data.msg
              });
              return false;
            }
            that.$Modal.info({
              title: '提示',
              content: "基本配置保存成功"
            });
            that.initPage();
          });
        },
        reset:function () {
          if(this.tabValue=="1"){
            this.phoneIsHide="0";
            this.phoneOwnership="0";
            this.phoneNumber="1";
            this.maxAgent="1";
            this.waitVisitDays="3";
            this.recoveryTime="0";
            this.seaSet=[];
            this.recoveryDays="5";
            this.recoveryNoticeTime="0";
            this.handleTime="";
            this.stopAgentStatus=[];
            this.autoClose="1";
            this.isAllowModify="1";
            this.isSeeMisscall="0";
            this.externalPhoneAutoAnswer="0";
            this.forceEvalue="0";
            this.selRing='0';
            this.timeShowStyle='1';
            this.isHiddenService='0';
            this.screenShow='0';
          }
          if(this.tabValue=="2"){
            this.templateName='';
            this.isUse='0';
            this.noteUrl="";
            this.requestHead="";
            this.paramType="0";
            this.successCode="";
            this.requestBody="";
          }
          if(this.tabValue=="3"){
            this.outEmailAddress="";
            this.mailServer="";
            this.mailServerPort="";
            this.emailAuthentication="";
            this.userName="";
            this.passWord="";
            this.receiveEmailAddress="";
          }
          if(this.tabValue=="5"){
            this.bigScreenLogo="";
            this.bigScreenBgp="";
            this.callView="";
            this.workPlace="";
          }
        },
        changeTab:function(){
          this.initPage();
        },
        initPage:function () {
          let that=this;
          let param={
            journalType:"null",
            menuId:"null",
            type:this.tabValue
          };
          this.spinShow=true;
          this.$http.post("config/selectConfig.json",param) .then(function (res) {
            let result = res.data.flag;
            that.spinShow=false;
            if (result != "666") {
              that.$Modal.info({
                title: '提示',
                content: res.data.msg
              });
              return false;
            }
            that.configId='';
            that.requestBody='';
            that.ringList=res.data.obj.ringList;
            that.noteList=[];
            let count=0;
            if(res.data.obj.configList && res.data.obj.configList.length > 0){
              if(that.tabValue=='2'){
                let newList=res.data.obj.configList;
                for(let i=0;i<newList.length;i++){
                  let configValue=JSON.parse(newList[i].configValue);
                  if("1"==newList[i].isUse){
                    that.configId=newList[i].id;
                    that.isUse=newList[i].isUse;
                    that.noteUrl=configValue.url;
                    that.paramType=configValue.paramType;
                    that.requestBody=configValue.body;
                    that.requestHead=configValue.head;
                    that.type=configValue.type;
                    that.successCode=configValue.successCode;
                    that.templateName=configValue.templateName;
                    count++;
                  }
                  let param={
                    id:newList[i].id,
                    isUse:newList[i].isUse,
                    noteUrl:configValue.url,
                    requestHead:configValue.head,
                    paramType:configValue.paramType,
                    successCode:configValue.successCode,
                    requestBody:configValue.body,
                    type:configValue.type,
                    templateName:configValue.templateName,
                  }
                  that.noteList.push(param);
                }
                let paramTwo={
                  id:'',
                  isUse:'0',
                  noteUrl:'',
                  requestHead:'',
                  paramType:'0',
                  successCode:'',
                  type:'0',
                  requestBody:'',
                  templateName:'',
                }
                that.noteList.push(paramTwo);
                if(count==0 && newList.length!=0){
                  let configValue=JSON.parse(newList[0].configValue);
                  that.configId=newList[0].id;
                  that.isUse=newList[0].isUse;
                  that.noteUrl=configValue.url;
                  that.paramType=configValue.paramType;
                  that.requestBody=configValue.body;
                  that.requestHead=configValue.head;
                  that.type=configValue.type;
                  that.successCode=configValue.successCode;
                  that.templateName=configValue.templateName;
                }
                return;
              }
              that.configId=res.data.obj.configList[0].id;
              that.configValue=JSON.parse(res.data.obj.configList[0].configValue);
              if(that.configValue){
                that.phoneIsHide=that.configValue.phoneIsHide;
                that.selRing=that.configValue.selRing;
                that.companyLogo=that.configValue.companyLogo;
                that.phoneOwnership=that.configValue.phoneOwnership;
                that.phoneNumber=that.configValue.requestCustomerNum;
                that.maxAgent=that.configValue.agentMaxCustomersNum;
                that.waitVisitDays=that.configValue.waitVisitDays;
                that.recoveryTime=that.configValue.resumAgentWhenRejectStatus;
                if(that.configValue.seaSet){
                  that.seaSet=that.configValue.seaSet.split(",");
                }
                that.recoveryDays=that.configValue.recoveryDays;
                that.recoveryNoticeTime=that.configValue.recoveryNoticeTime;
                that.handleTime=that.configValue.afterDoTime ;
                if(that.configValue.agentState){
                  that.stopAgentStatus=that.configValue.agentState.split(",");
                }
                that.autoClose=that.configValue.popSaveFlag;
                that.isAllowModify=that.configValue.isModifyManager;
                console.log(that.configValue.isSeeMisscall);
                that.isSeeMisscall=that.configValue.isSeeMisscall;
                if(that.isSeeMisscall==undefined){
                    that.isSeeMisscall="0";
                }
                that.externalPhoneAutoAnswer=that.configValue.externalPhoneAutoAnswer;
                that.forceEvalue=that.configValue.forceEvalue;
                that.isHiddenService=that.configValue.isHiddenService == '1'?'1':'0';
                that.screenShow=that.configValue.screenShow == '1'?'1':'0';
                //邮箱
                that.outEmailAddress=that.configValue.outEmailAddress;
                that.mailServer=that.configValue.mailServer;
                that.mailServerPort=that.configValue.mailServerPort;
                that.emailAuthentication=that.configValue.emailAuthentication;
                that.userName=that.configValue.userName;
                that.passWord=that.configValue.passWord;
                that.receiveEmailAddress=that.configValue.receiveEmailAddress;
                that.bigScreenBgp=that.configValue.bgImg;
                that.bigScreenLogo=that.configValue.logo;
                that.callView=that.configValue.callView;
                that.workPlace=that.configValue.workPlace;
                //获取快速应用的初始值
                if (that.configValue && that.configValue.length> 0) {
                    that.fastApplication=that.configValue;
                }
              }
              that.timeShowStyle=that.configValue.timeShowStyle;
            }
          });
        }
      },
      watch:{
        pageCode:function () {
          if(this.pageCode=='3_3' && this.showPageCount==0){
            this.showPageCount++;
            this.initPage();
          }
        }
      },
      created(){
        // this.screenHeight.height=this.mountHeight(133);
        // this.tanPaneHeight.height=this.mountHeight(183);
        this.screenHeight.height=this.mountHeight(133);
        this.tanPaneHeight.height=this.mountHeight(200);
      }
    }
</script>

<style lang="less" scoped>
  .basic_dialog /deep/ .el-dialog__body{
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/BasicConfig.vue